export default "__VITE_ASSET__ZCG0OfVW__"